<template>
  <div v-if="description" class="product-details-description">
    <div class="product-details-description__title">
      {{ $t('PRODUCT DESCRIPTION') }}
    </div>
    <div
      v-if="'html' in description"
      class="product-details-description__html"
      v-html="description.html"
    />
    <LogoMadeInItaly class="product-details-description__logo" />
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { LogoMadeInItaly } from '~/components/General/Logo';

export default defineComponent({
  name: 'ProductDetailsDescription',
  components: {
    LogoMadeInItaly,
  },
  props: {
    description: {
      type: Object,
      default: () => null,
    },
  },
  setup() {
    return {};
  },
});
</script>

<style lang="scss" scoped>
.product-details-description {
  &__title {
    @include label-s;
    padding-bottom: 1.25rem;
  }
  &__html {
    padding-bottom: 2.5rem;
  }
}
</style>

<style lang="scss">
.product-details-description {
  &__html {
    ul {
      padding: 0;
      margin: 0;
      li {
        list-style-type: none;
        @include paragraph-xl;
        p {
          margin: 0;
        }
        &:first-child {
          @include mobile-h5;
        }
      }
    }
  }
  @include from-desktop-min {
    &__html {
      ul {
        li {
          &:first-child {
            @include desktop-h5;
          }
        }
      }
    }
  }
}
</style>
